import * as Sentry from '@sentry/react';
import { setupGlobalErrorHandlers, createSentryBeforeSend } from '@gqlapp/core-client-react/utils/sentryEventProcessor';
import { initBasicSentryConfiguration } from '@gqlapp/core-client-react/utils/sentryUtils';

import modules from './modules';

const { version } = require('../package.json');

Sentry.init({
  dsn: __REACT_APP_SENTRY_DSN__,
  release: __REACT_APP_SENTRY_RELEASE__,
  dist: version,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false
    })
  ],
  tracesSampleRate: Number(__REACT_APP_SENTRY_TRACES_SAMPLE_RATE__),
  tracePropagationTargets: __REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS__?.split(','),
  replaysSessionSampleRate: Number(__REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE__),
  replaysOnErrorSampleRate: Number(__REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE__),
  profilesSampleRate: Number(__REACT_APP_SENTRY_PROFILES_SAMPLE_RATE__),
  beforeSend: createSentryBeforeSend({
    addTimePrefix: true,
    includeSession: true
  })
});

initBasicSentryConfiguration();
setupGlobalErrorHandlers();

(async () => {
  await modules.createApp(module);
})();

export default modules;
